import { useEffect } from "react";

function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="services">
      <div className="container">
        <header className="section-header">
          <p>Terms & Conditions</p>
        </header>

        <div className="row">
          <div className="col-12">
            <div className="fortHeadingTerm">Terms & Conditions</div>
            <p className="termP">
              Welcome to Pratham, the innovative platform by Assert AI that
              empowers users to unlock the potential of their videos through
              advanced analytics. By using our Services, you agree to these
              Terms.
            </p>
            <div className="fortHeadingTerm">Who We Are</div>
            <p className="termP">
              Assert AI is dedicated to revolutionizing the AI landscape,
              ensuring that artificial intelligence benefits humanity. For more
              information, visit our website at assertai.com.
            </p>
            <div className="fortHeadingTerm">Registration and Access</div>
            <p className="termP">
              You must provide accurate information to register for an account.
              Your account credentials are for your use only, and you're
              responsible for all activities under your account.
            </p>
            <div className="fortHeadingTerm">Using Our Services</div>
            <p className="termP">
              You may access and use our Services in compliance with applicable
              laws and our policies. However, you may not engage in illegal,
              harmful, or abusive activities.
            </p>
            <div className="fortHeadingTerm">What You Can Do</div>
            <p className="termP">
              You can upload videos and receive relevant analytics based on your
              video content.
            </p>
            <div className="fortHeadingTerm">What You Cannot Do</div>
            <p className="termP">
              You cannot modify, copy, sell, or distribute our Services. Reverse
              engineering or representing output as human-generated is
              prohibited.
            </p>
            <div className="fortHeadingTerm">Content</div>
            <p className="termP">
              You own the input and output generated by our Services. You may
              use the analytics for identifying bottlenecks in your operations
              and business processes.
            </p>
            <div className="fortHeadingTerm">Our Use of Content</div>
            <p className="termP">
              We may use content to improve our Services, for product
              development, research and marketing.
            </p>
            <div className="fortHeadingTerm">Opt Out</div>
            <p className="termP">
              You can opt out of allowing us to use your content to train our
              models. Please write to us at{" "}
              <a href="mailto:info@assertai.com">info@assertai.com</a> if you
              wish to do so
            </p>
            <div className="fortHeadingTerm">Accuracy</div>
            <p className="termP">
              Output may not always be accurate. You should evaluate output
              before making decisions based on it.
            </p>
            <div className="fortHeadingTerm">Termination and Suspension</div>
            <p className="termP">
              We may suspend or terminate your access if you breach these Terms
              or engage in harmful activities.
            </p>
            <div className="fortHeadingTerm">Discontinuation of Services</div>
            <p className="termP">
              We may discontinue our Services with advance notice and provide
              refunds for prepaid, unused services.
            </p>
            <div className="fortHeadingTerm">Disclaimer of Warranties</div>
            <p className="termP">
              Our Services are provided "as is," and we disclaim all warranties.
              We are not liable for any indirect or incidental damages.
            </p>
            <div className="fortHeadingTerm">Copyright Complaints</div>
            <p className="termP">
              If you believe your intellectual property rights have been
              infringed, contact us.
            </p>
            <div className="fortHeadingTerm">General Terms</div>
            <p className="termP">
              You may not assign your rights under these Terms. We may update
              these Terms from time to time with notice. <br />
              By using our Services, you agree to abide by these Terms. If you
              have any questions, please contact us.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Terms;
